import type { ChangeEvent } from 'react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useDispatch } from 'store/configureStore';

import { setReceiveWhatsappNotification } from 'actions';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { ReactComponent as WhatsappIcon } from 'icons/ico-whatsapp.svg';
import { shouldReceiveWhatsappNotification } from 'selectors';
import { useTranslations } from 'utils';

const CheckWhatsappNotification = () => {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const receiveWhatsappNotification = useSelector(
    shouldReceiveWhatsappNotification,
  );

  const handleCheckboxChange = ({
    target: { checked },
  }: ChangeEvent<HTMLInputElement>) => {
    dispatch(setReceiveWhatsappNotification(checked));
  };

  useEffect(() => {
    dispatch(setReceiveWhatsappNotification(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mt-4 flex" data-testid="checkWhatsappNotification">
      <Checkbox
        name="receiveWhatsappNotification"
        label=<div>
          <span className="mr-2">
            {i18n.t(
              'senderInformation.receiveWhatsappNotification.checkboxText',
            )}
          </span>
          <WhatsappIcon />
        </div>
        checked={receiveWhatsappNotification || false}
        onChange={handleCheckboxChange}
      />
    </div>
  );
};

export { CheckWhatsappNotification };
